import type { Mixpanel } from "./mixpanel-types.ts"

import { getTrackingHTML } from "./__get-tracking-html.tsx"

const MIXPANEL_PROXY_DOMAIN = "https://mp.iyk.app"

export const MixpanelTracking = ({ id, ...config }: MixpanelTracking.Props) => {
  if (!id) return null
  return (
    <script
      dangerouslySetInnerHTML={getTrackingHTML(
        `mixpanel=[]`,
        `mixpanel._i=[]`,
        `mixpanel.__SV=1.2`,
        `mixpanel.people=[]`,
        `mixpanel.toString=e=>e?"mixpanel":"mixpanel (stub)"`,
        `mixpanel.people.toString=()=>mixpanel.toString(!0)+".people (stub)"`,
        `mixpanel.init=(e,t)=>{let p=(e,t)=>{let p=t.split(".");2===p.length&&(e=e[p[0]],t=p[1]),e[t]=(...p)=>{e.push([t].concat(p))}},n=["disable","time_event","track","track_pageview","track_links","track_forms","track_with_groups","add_group","set_group","remove_group","register","register_once","alias","unregister","identify","name_tag","set_config","reset","opt_in_tracking","opt_out_tracking","has_opted_in_tracking","has_opted_out_tracking","clear_opt_in_out_tracking","start_batch_senders","people.set","people.set_once","people.unset","people.increment","people.append","people.union","people.track_charge","people.clear_charges","people.delete_user","people.remove"];for(let e of n)p(mixpanel,e);let o=["set","set_once","union","unset","remove","delete"];mixpanel.get_group=(...e)=>{let t={};for(let p of o)t[p]=(...t)=>{mixpanel.push([["get_group",...e],[p,...t]])};return t},mixpanel._i.push([e,t,"mixpanel"])}`,
        `mixpanel.init(${JSON.stringify(id)},${JSON.stringify({
          ...config,
          api_host: MIXPANEL_PROXY_DOMAIN,
        })})`,
      )(`${MIXPANEL_PROXY_DOMAIN}/lib.min.js`)}
    />
  )
}

export namespace MixpanelTracking {
  export interface Props extends Partial<Mixpanel.Config> {
    id?: string | null | undefined
  }
}
